import { useState, useContext } from "react";
import * as StyledDOM from "./CandidateInfo.jsx";
import Chip from "@mui/material/Chip";
import mailIcon from "../../../../Assets/Images/mail-icon_blue.svg";
import salaryIcon from "../../../../Assets/Images/mage_dollar.svg";
import phoneIcon from "../../../../Assets/Images/phone-icon_blue.svg";
import locationIcon from "../../../../Assets/Images/location-icon_blue.svg";
import birthdayIcon from "../../../../Assets/Images/iconoir_birthday-cake.svg";
import dropDownIconLight from "../../../../Assets/Images/drop-down-light-icon.svg";
import dropDownIconDark from "../../../../Assets/Images/drop-down-dark-icon.svg";
import dropUpIconLight from "../../../../Assets/Images/drop-up-light-icon.svg";
import dropUpIconDark from "../../../../Assets/Images/drop-up-dark-icon.svg";
import ReadMore from "../../../../Common/ReadMore/ReadMore.jsx";
import AutoComplete from "../../../../Common/AutoComplete/AutoComplete";
import OptionsData from "../../../../Assets/Json/StaticOptions.json";
import DynamicAutocomplete from "../../../../Common/AutoSuggestion/DynamicAutocomplete.js";
import { DynamicContext } from "../../../../Context/DynamicContext.js";
import customFieldIcon from "../../../../Assets/Images/custom-field-icon.svg";
import jobCustomFieldsIcon from "../../../../Assets/Images/experience_icon.svg";

function PersonalInfoRow({ icon, label, value }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "14px 20px",
      }}
    >
      <span style={{ color: "var(--text-color-accent)", flexShrink: 0 }}>
        {icon}
      </span>
      <span
        style={{
          fontSize: "14px",
          fontWeight: 500,
          color: "var(--text-color-accent)",
          minWidth: "120px",
          flexShrink: 0,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: "14px",
          fontWeight: 500,
          color: "var(--header__color)",
        }}
      >
        {value}
      </span>
    </div>
  );
}

function CandidateInfo(props) {
  const { assignedVendor = "", isVendorFeatureEnabled } = props || {};
  const { isDarkMode } = useContext(DynamicContext);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const candidate = selectedCandidate?.candidate || props?.candidate || {};
  const JOB_CUSTOM_FIELDS = candidate?.job_custom_fields;

  const [showPersonal, setShowPersonal] = useState(true);
  const [showAcademic, setShowAcademic] = useState(false);
  const [showCareer, setShowCareer] = useState(false);

  const {
    parsedResumeData: {
      EducationHistory = [],
      CertificationsAndLicenses = [],
      CareerHistory: { JobDetails = [] } = {},
    } = {},
  } = candidate || {};

  const skillsToDisplay = Array.isArray(candidate.skills)
    ? candidate.skills
    : candidate.parsedResumeData?.Skills || [];
  const { StaticOptions = {} } = OptionsData || {};
  const { skills = [], visaStatus = [] } = StaticOptions || {};

  const isEditingCandidate = props?.isEditingCandidate || false;
  const handleCandidateChange = props?.handleCandidateChange || (() => {});
  const editedCandidateData = props?.editedCandidateData || null;
  return (
    <StyledDOM.InfoMainContainer>
      {/* ── Personal Info Card ───────────────────────────────────────────── */}
      <div
        style={{
          border: "1px solid var(--accordian-border)",
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "16px",
        }}
      >
        {/* Card header / toggle */}
        <div
          onClick={() => setShowPersonal((prev) => !prev)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            cursor: "pointer",
            borderBottom: showPersonal
              ? "1px solid var(--accordian-border)"
              : "none",
            backgroundColor: "var(--accordian-background)",
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: "16px",
              color: "var(--header__color)",
            }}
          >
            Personal Info
          </span>
          <span style={{ display: "flex", alignItems: "center" }}>
            {showPersonal ? (
              isDarkMode ? (
                <img
                  src={dropDownIconDark}
                  style={{ width: "20px", height: "20px" }}
                  alt="drop down"
                />
              ) : (
                <img
                  src={dropDownIconLight}
                  style={{ width: "20px", height: "20px" }}
                  alt="drop down"
                />
              )
            ) : isDarkMode ? (
              <img
                src={dropUpIconDark}
                style={{ width: "20px", height: "20px" }}
                alt="drop up"
              />
            ) : (
              <img
                src={dropUpIconLight}
                style={{ width: "20px", height: "20px" }}
                alt="drop up"
              />
            )}
          </span>
        </div>

        {showPersonal && (
          <>
            <StyledDOM.StyledPersonalInfoSkillDiv className="skill-container">
              <StyledDOM.InfoLabel style={{ marginRight: "30px" }}>
                Skills
              </StyledDOM.InfoLabel>
              {isEditingCandidate ? (
                <AutoComplete
                  multiple
                  placeholder="Select skills"
                  value={(() => {
                    const autoCompleteValue =
                      editedCandidateData?.skills !== undefined
                        ? Array.isArray(editedCandidateData.skills)
                          ? editedCandidateData.skills
                          : []
                        : Array.isArray(skillsToDisplay)
                          ? skillsToDisplay
                          : [];
                    return autoCompleteValue;
                  })()}
                  options={skills.filter((skill) => {
                    const currentSkills =
                      editedCandidateData?.skills !== undefined
                        ? Array.isArray(editedCandidateData.skills)
                          ? editedCandidateData.skills
                          : []
                        : Array.isArray(skillsToDisplay)
                          ? skillsToDisplay
                          : [];
                    return !currentSkills.some(
                      (selectedSkill) =>
                        selectedSkill.toLowerCase() ===
                        skill.title.toLowerCase(),
                    );
                  })}
                  tags={true}
                  onChange={(selectedOptions) => {
                    const validSkills = selectedOptions
                      .map((option) => {
                        if (typeof option === "string") {
                          return option.trim();
                        } else if (
                          option &&
                          typeof option === "object" &&
                          option.title
                        ) {
                          return option.title.trim();
                        }
                        return "";
                      })
                      .filter((option) => option !== "");
                    const uniqueSkills = validSkills.filter(
                      (skill, index, self) =>
                        index ===
                        self.findIndex(
                          (s) => s.toLowerCase() === skill.toLowerCase(),
                        ),
                    );

                    handleCandidateChange({ skills: uniqueSkills });
                  }}
                  InputWrapperStyle={{
                    height: "60px",
                    overflowY: "auto",
                    padding: "5px",
                  }}
                  showClearAll={true}
                />
              ) : (
                <ReadMore maxItems={20}>
                  {skillsToDisplay.length > 0 ? (
                    skillsToDisplay.map((skill, index) => (
                      <Chip
                        key={index}
                        label={skill}
                        style={{
                          marginRight: "5px",
                          marginBottom: "5px",
                          backgroundColor: "var(--skill-badge-bg)",
                          border: "1px solid var(--skill-badge-border)",
                          color: "var(--skill-badge-color)",
                          fontsize: "14px",
                          fontWeight: "500",
                        }}
                      />
                    ))
                  ) : (
                    <span>No skills listed</span>
                  )}
                </ReadMore>
              )}
            </StyledDOM.StyledPersonalInfoSkillDiv>
            {/* Personal Info Grid */}
            <StyledDOM.PersonalInfoGrid>
              {/* Left column */}
              <div>
                <PersonalInfoRow
                  icon={
                    <img
                      src={birthdayIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Date of Birth"
                  value={
                    candidate.parsedResumeData?.BasicInfo?.BirthDate || "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={salaryIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Preferred Salary"
                  value={
                    candidate.preferred_salary ||
                    candidate.parsedResumeData?.BasicInfo?.preferred_salary ||
                    "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={phoneIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Secondary Phone"
                  value={
                    candidate.secondaryPhone ||
                    candidate.parsedResumeData?.BasicInfo?.SecondaryPhone ||
                    "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Zip Code"
                  value={
                    candidate.zip_code ||
                    candidate.parsedResumeData?.BasicInfo?.zip_code ||
                    "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Designation"
                  value={
                    candidate.designation && candidate.designation.trim() !== ""
                      ? candidate.designation
                      : candidate.parsedResumeData?.CareerHistory
                            ?.JobDetails?.[0]?.JobTitle
                        ? candidate.parsedResumeData.CareerHistory.JobDetails[0]
                            .JobTitle
                        : "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Source"
                  value={
                    candidate.source && candidate.source.trim() !== ""
                      ? candidate.source
                      : "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Industry"
                  value={
                    candidate.industry && candidate.industry.trim() !== ""
                      ? candidate.industry
                      : "N/A"
                  }
                />
                {props.candidateCustomFields
                  .filter((_, index) => index % 2 === 0)
                  .map((i) => (
                    <PersonalInfoRow
                      key={i.field_key}
                      icon={
                        <img
                          src={customFieldIcon}
                          alt=""
                          style={{ width: "16px", height: "16px" }}
                        />
                      }
                      label={i.label}
                      value={String(i.value) || "—"}
                    />
                  ))}
              </div>

              {/* Right column */}
              <div>
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Location"
                  value={
                    [
                      candidate.city ||
                        candidate.parsedResumeData?.BasicInfo
                          ?.CurrentLocationCity,
                      candidate.state ||
                        candidate.parsedResumeData?.BasicInfo
                          ?.CurrentLocationState,
                      candidate.country ||
                        candidate.parsedResumeData?.BasicInfo
                          ?.CurrentLocationCountry,
                    ]
                      .filter(Boolean)
                      .join(", ") || "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={mailIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Secondary Email"
                  value={
                    candidate.secondaryEmail ||
                    candidate.parsedResumeData?.BasicInfo?.SecondaryEmail ||
                    "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Address"
                  value={
                    [
                      candidate.line_address_1 ||
                        candidate.parsedResumeData?.BasicInfo?.line_address_1,
                      candidate.line_address_2 ||
                        candidate.parsedResumeData?.BasicInfo?.line_address_2,
                    ]
                      .filter(Boolean)
                      .join(", ") || "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Visa Status"
                  value={
                    candidate.visaStatus ||
                    candidate.parsedResumeData?.BasicInfo?.VisaStatus ||
                    "—"
                  }
                />
                <PersonalInfoRow
                  icon={
                    <img
                      src={locationIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  }
                  label="Remarks"
                  value={candidate.remarks || "—"}
                />
                {props.candidateCustomFields
                  .filter((_, index) => index % 2 !== 0)
                  .map((i) => (
                    <PersonalInfoRow
                      key={i.field_key}
                      icon={
                        <img
                          src={customFieldIcon}
                          alt=""
                          style={{ width: "16px", height: "16px" }}
                        />
                      }
                      label={i.label}
                      value={String(i.value) || "—"}
                    />
                  ))}
              </div>
            </StyledDOM.PersonalInfoGrid>

            {isVendorFeatureEnabled && assignedVendor?.name && (
              <StyledDOM.CandidateContentLabelDiv className="candidateinfo-content">
                <StyledDOM.CandidateContentLabelDiv className="candidateinfo-label">
                  <img
                    src={locationIcon}
                    alt="vendor-icon"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "25px",
                    }}
                  />
                  <StyledDOM.PersonalInfoLabel style={{ marginTop: "25px" }}>
                    Vendor (Optional)
                  </StyledDOM.PersonalInfoLabel>
                </StyledDOM.CandidateContentLabelDiv>
                <StyledDOM.InfoValue style={{ marginTop: "25px" }}>
                  {assignedVendor?.name
                    ? `${assignedVendor.name}${
                        assignedVendor.contact_person
                          ? ` - ${assignedVendor.contact_person}`
                          : ""
                      }`
                    : "N/A"}
                </StyledDOM.InfoValue>
              </StyledDOM.CandidateContentLabelDiv>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "10px 20px",
              }}
            >
              {Array.isArray(JOB_CUSTOM_FIELDS) &&
                JOB_CUSTOM_FIELDS.map((field, index) => {
                  const customFields = Object.entries(field).filter(
                    ([key]) => key !== "job_title",
                  );

                  return (
                    <div
                      key={index}
                      style={{
                        border: "1px solid var(--accordian-border)",
                        borderRadius: "14px",
                        padding: "18px 24px",
                        backgroundColor: "var(--background-color)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          marginBottom: "20px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "10px",
                            backgroundColor: "#eeedff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <img
                            src={jobCustomFieldsIcon}
                            alt="job"
                            style={{
                              width: "22px",
                              height: "22px",
                            }}
                          />
                        </div>

                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "var(--header__color)",
                          }}
                        >
                          Job: {field.job_title || "Untitled Job"}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          columnGap: "0",
                          rowGap: "0",
                        }}
                      >
                        {customFields.map(([key, value], fieldIndex) => (
                          <div
                            key={key}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              minHeight: "48px",
                              padding: "8px 20px 8px 0",
                              paddingLeft: fieldIndex % 2 !== 0 ? "20px" : "0",
                            }}
                          >
                            <img
                              src={customFieldIcon}
                              alt="custom field"
                              style={{
                                width: "16px",
                                height: "16px",
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                color: "var(--text-color-accent)",
                                fontSize: "14px",
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </span>
                            <span
                              style={{
                                color: "var(--header__color)",
                                fontSize: "14px",
                                fontWeight: 500,
                              }}
                            >
                              {value !== null &&
                              value !== undefined &&
                              value !== ""
                                ? String(value)
                                : "—"}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
      <div
        style={{
          border: "1px solid var(--accordian-border)",
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "16px",
        }}
      >
        {candidate.parsedResumeData && (
          <>
            <div
              onClick={() => setShowAcademic((prev) => !prev)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                cursor: "pointer",
                borderBottom: showAcademic
                  ? "1px solid var(--accordian-border)"
                  : "none",
                backgroundColor: "var(--accordian-background)",
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  color: "var(--header__color)",
                }}
              >
                Academic Info
              </span>
              <span style={{ display: "flex", alignItems: "center" }}>
                {showAcademic ? (
                  isDarkMode ? (
                    <img
                      src={dropDownIconDark}
                      style={{ width: "20px", height: "20px" }}
                      alt="drop down"
                    />
                  ) : (
                    <img
                      src={dropDownIconLight}
                      style={{ width: "20px", height: "20px" }}
                      alt="drop down"
                    />
                  )
                ) : isDarkMode ? (
                  <img
                    src={dropUpIconDark}
                    style={{ width: "20px", height: "20px" }}
                    alt="drop up"
                  />
                ) : (
                  <img
                    src={dropUpIconLight}
                    style={{ width: "20px", height: "20px" }}
                    alt="drop up"
                  />
                )}
              </span>
            </div>

            {showAcademic && candidate.parsedResumeData && (
              <>
                <StyledDOM.ContentDetailsMainDiv>
                  <StyledDOM.InfoHeader
                    style={{ color: "#6860EE", fontSize: "20px" }}
                  >
                    Education Details
                  </StyledDOM.InfoHeader>
                  <div>
                    {EducationHistory.length > 0 ? (
                      candidate.parsedResumeData.EducationHistory.map(
                        (edu, index) => (
                          <StyledDOM.InfoContentMainDiv
                            key={index}
                            className="candidate-contentDiv"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <StyledDOM.InfoValue
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                }}
                              >
                                {edu.Degree}
                                {edu.FieldOfStudy
                                  ? `, ${edu.FieldOfStudy}`
                                  : ""}
                              </StyledDOM.InfoValue>
                              <StyledDOM.Date>
                                {edu.GraduationDate}
                              </StyledDOM.Date>
                            </div>
                            <StyledDOM.InfoLabel>
                              {edu.Institute} - {edu.InstituteLocationCity},{" "}
                              {edu.InstituteLocationCountry}
                            </StyledDOM.InfoLabel>
                          </StyledDOM.InfoContentMainDiv>
                        ),
                      )
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>
                </StyledDOM.ContentDetailsMainDiv>

                <StyledDOM.ContentDetailsMainDiv>
                  <StyledDOM.InfoHeader
                    style={{ color: "#6860EE", fontSize: "20px" }}
                  >
                    Certification
                  </StyledDOM.InfoHeader>
                  <div>
                    {CertificationsAndLicenses.length > 0 ? (
                      candidate.parsedResumeData.CertificationsAndLicenses.map(
                        (cert, index) => (
                          <StyledDOM.InfoContentMainDiv
                            key={index}
                            className="candidate-contentDiv"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                              width: "100%",
                              marginBottom: "10px",
                              fontSize: "16px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <StyledDOM.InfoValue
                                style={{ margin: 0, fontSize: "16px" }}
                              >
                                {cert.CertificationName}
                              </StyledDOM.InfoValue>
                              <StyledDOM.Date>{cert.IssueDate}</StyledDOM.Date>
                            </div>
                            <StyledDOM.InfoLabel>
                              {cert.IssuingOrganization}
                            </StyledDOM.InfoLabel>
                          </StyledDOM.InfoContentMainDiv>
                        ),
                      )
                    ) : (
                      <span>N/A</span>
                    )}
                  </div>
                </StyledDOM.ContentDetailsMainDiv>
              </>
            )}
          </>
        )}
      </div>
      <div
        style={{
          border: "1px solid var(--accordian-border)",
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "16px",
        }}
      >
        {candidate.parsedResumeData && (
          <>
            <div
              onClick={() => setShowCareer((prev) => !prev)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                cursor: "pointer",
                borderBottom: showCareer
                  ? "1px solid var(--accordian-border)"
                  : "none",
                backgroundColor: "var(--accordian-background)",
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  color: "var(--header__color)",
                }}
              >
                Career Info
              </span>
              <span style={{ display: "flex", alignItems: "center" }}>
                {showCareer ? (
                  isDarkMode ? (
                    <img
                      src={dropDownIconDark}
                      style={{ width: "20px", height: "20px" }}
                      alt="drop down"
                    />
                  ) : (
                    <img
                      src={dropDownIconLight}
                      style={{ width: "20px", height: "20px" }}
                      alt="drop down"
                    />
                  )
                ) : isDarkMode ? (
                  <img
                    src={dropUpIconDark}
                    style={{ width: "20px", height: "20px" }}
                    alt="drop up"
                  />
                ) : (
                  <img
                    src={dropUpIconLight}
                    style={{ width: "20px", height: "20px" }}
                    alt="drop up"
                  />
                )}
              </span>
            </div>

            {showCareer && candidate.parsedResumeData && (
              <StyledDOM.ContentDetailsMainDiv>
                <StyledDOM.InfoHeader
                  style={{ color: "#6860EE", fontSize: "20px" }}
                >
                  Career History
                </StyledDOM.InfoHeader>
                <div>
                  {JobDetails.length > 0 ? (
                    candidate.parsedResumeData.CareerHistory.JobDetails.map(
                      (prof, index) => (
                        <StyledDOM.InfoContentMainDiv
                          key={index}
                          className="candidate-contentDiv"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            width: "100%",
                            marginBottom: "10px",
                            alignItems: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <StyledDOM.InfoValue
                              style={{ margin: 0, fontSize: "16px" }}
                            >
                              {prof.JobTitle}
                            </StyledDOM.InfoValue>
                            <StyledDOM.Date>
                              {prof.StartDate} - {prof.EndDate}
                            </StyledDOM.Date>
                          </div>
                          <StyledDOM.InfoLabel>
                            {prof.JobCompany} - {prof.JobLocationCity},{" "}
                            {prof.JobLocationCountry}
                          </StyledDOM.InfoLabel>
                        </StyledDOM.InfoContentMainDiv>
                      ),
                    )
                  ) : (
                    <span>N/A</span>
                  )}
                </div>
              </StyledDOM.ContentDetailsMainDiv>
            )}
          </>
        )}
      </div>
    </StyledDOM.InfoMainContainer>
  );
}

export default CandidateInfo;
